var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9515 4.50436C17.8413 4.39739 17.7101 4.31247 17.5656 4.25453C17.4211 4.19658 17.2661 4.16675 17.1095 4.16675C16.953 4.16675 16.798 4.19658 16.6535 4.25453C16.509 4.31247 16.3778 4.39739 16.2675 4.50436L7.43248 13.019L3.72057 9.4351C3.6061 9.32868 3.47098 9.245 3.32291 9.18884C3.17484 9.13268 3.01673 9.10514 2.8576 9.10779C2.69848 9.11044 2.54145 9.14323 2.39549 9.20428C2.24953 9.26534 2.11749 9.35347 2.00692 9.46364C1.89635 9.5738 1.8094 9.70385 1.75105 9.84636C1.6927 9.98887 1.66408 10.141 1.66684 10.2942C1.66959 10.4473 1.70366 10.5985 1.7671 10.7389C1.83054 10.8794 1.9221 11.0065 2.03657 11.1129L6.59048 15.4958C6.70073 15.6028 6.83189 15.6877 6.97641 15.7456C7.12092 15.8036 7.27593 15.8334 7.43248 15.8334C7.58904 15.8334 7.74404 15.8036 7.88856 15.7456C8.03307 15.6877 8.16423 15.6028 8.27448 15.4958L17.9515 6.18218C18.0719 6.0753 18.168 5.94558 18.2337 5.8012C18.2994 5.65682 18.3333 5.5009 18.3333 5.34327C18.3333 5.18565 18.2994 5.02973 18.2337 4.88535C18.168 4.74096 18.0719 4.61125 17.9515 4.50436Z",
    fill: "#519A71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.4fd03993.svg";
export { ForwardRef as ReactComponent };